<p-contextMenu #lineTextMenu [model]="lineTextContextMenuItems"></p-contextMenu>
<div class="item-table-shell flex flex-col gap-6 text-[14px] rounded-xl border p-6 shadow font-sans" style="width: 100%">
    <h2 class="text-xl font-bold text-primary mb-4 border-b pb-2 flex items-center gap-2"><i class="pi pi-list"></i> Item Lines</h2>
    <div class="w-full item-table-wrap">
        <p-table
            #dt1
            [value]="sortedItemList"
            [globalFilterFields]="['itemName', 'itemNumber', 'rate', 'amount']"
            [rowHover]="true"
            [style]="{ width: '100%' }"
            [tableStyle]="{ 'min-width': '2400px' }"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
            [showGridlines]="true"
            filterDisplay="menu"
            class="border rounded-xl item-lines-table"
            [scrollable]="true"
            scrollDirection="horizontal"
        >
            <ng-template #caption>
                <div class="flex justify-between items-center flex-wrap gap-4 w-full">
                    <div class="flex items-center gap-2" >
                        <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt1)"></button>
                        <p-button label="{{ isEditingRates ? 'Done' : 'Edit' }}" icon="pi pi-pencil" (onClick)="toggleEditingRates()" outlined *ngIf="!isReadOnly && !readOnly "></p-button>
                    </div>
                    <div class="flex items-center gap-2">
                        <span class="p-input-icon-left">
                            <p-iconfield>
                                <p-inputicon styleClass="pi pi-search" />
                                <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)" placeholder="Search..." />
                            </p-iconfield>
                        </span>
                    </div>
                    <!-- Summary Section -->
                    <div class="flex flex-col sm:flex-row gap-4 ml-auto">
                        <div class="font-semibold text-sm">
                            Total: <span class="text-primary">{{ (itemList || []).length }}</span> Articles
                        </div>
                        <div class="font-semibold text-sm">
                            Gross Value: <span class="text-primary">{{ getTotalValue() | number: '1.2-2' }}</span>
                        </div>
                        <div class="font-semibold text-sm" *ngIf="division !== '400'">
                            Total Discount Value: <span class="text-primary">{{ getTotalDiscountValue() | number: '1.2-2' }}</span>
                        </div>
                        <!-- New Net Amount -->
                        <div class="font-semibold text-sm">
                            Net Amount: <span class="text-primary">{{ getTotalNetAmount() | number: '1.2-2' }}</span>
                        </div>
                        <!-- New VAT Amount -->
                        <div class="font-semibold text-sm">
                            VAT Amount: <span class="text-primary">{{ getTotalVatAmount() | number: '1.2-2' }}</span>
                        </div>
                        <!-- New Total Weight -->
                        <div class="font-semibold text-sm">
                            Total Weight: <span class="text-primary">{{ getTotalWeight() | number: '1.2-2' }}</span>
                        </div>
                        <div class="font-semibold text-sm">
                            Order Value: <span class="text-primary">{{ getSubscription() | number: '1.2-2' }}</span>
                        </div>
                        <span
                            class="self-center ml-1 cursor-help"
                            pTooltip="Totals are calculated at order level; may differ from sum of line amounts by 0.01."
                            tooltipPosition="bottom"
                        >
                            <i class="pi pi-info-circle text-surface-500 text-xs"></i>
                        </span>
                    </div>
                </div>
            </ng-template>
            <!-- Table Header with Filters -->
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 70px; min-width: 70px; white-space: nowrap">
                        <span class="flex items-center gap-2 item-table-header-cell">
                            Ln No.
                        </span>
                    </th>
                    <th style="min-width: 440px; max-width: 440px; width: 440px">
                        <span class="flex items-center gap-2 item-table-header-cell"> Item </span>
                    </th>
                    <th style="width: 140px; min-width: 140px; white-space: nowrap">
                        <span class="flex items-center gap-2 item-table-header-cell"> Item No. </span>
                    </th>
                    <th style="width: 72px; min-width: 72px; white-space: nowrap">
                        <span class="flex items-center gap-2 item-table-header-cell"> Ln stat </span>
                    </th>
                    <th style="width: 80px; min-width: 80px; white-space: nowrap">
                        <span class="flex items-center gap-2 item-table-header-cell"> Qty </span>
                    </th>
                    <th style="width: 120px; min-width: 120px; white-space: nowrap">
                        <span class="flex items-center gap-2 item-table-header-cell"> Rate </span>
                    </th>
                    <th style="width: 100px; min-width: 100px; white-space: nowrap" *ngIf="division !== '400'">
                        <span class="flex items-center gap-2 item-table-header-cell"> Disc (%) </span>
                    </th>
                    <th style="width: 140px; min-width: 140px; white-space: nowrap" *ngIf="division !== '400'">
                        <span class="flex items-center gap-2 item-table-header-cell"> Disc Val </span>
                    </th>
                    <th style="width: 140px; min-width: 140px; white-space: nowrap">
                        <span class="flex items-center gap-2 item-table-header-cell"> Gross </span>
                    </th>
                    <th style="width: 100px; min-width: 100px; white-space: nowrap">
                        <span class="flex items-center gap-2 item-table-header-cell"> Net </span>
                    </th>
                    <th style="width: 90px; min-width: 90px; white-space: nowrap" *ngIf="showMarginColumns">
                        <span class="flex items-center gap-2 item-table-header-cell"> Margin % </span>
                    </th>
                    <th style="width: 80px; min-width: 80px; white-space: nowrap" *ngIf="showMarginColumns">
                        <span class="flex items-center gap-2 item-table-header-cell"> MCM % </span>
                    </th>
                    <th style="width: 140px; min-width: 140px; white-space: nowrap">
                        <span class="flex items-center gap-2 item-table-header-cell"> VAT (%) </span>
                    </th>
                    <th style="width: 120px; min-width: 120px; white-space: nowrap" class="item-table-col-vat-amt">
                        <span class="flex items-center gap-2 item-table-header-cell"> VAT Amt </span>
                    </th>
                    <th style="width: 120px; min-width: 120px; white-space: nowrap" class="item-table-col-ln-amt">
                        <span class="flex items-center gap-2 item-table-header-cell"> Ln Amt </span>
                    </th>
                    <th style="width: 120px; min-width: 120px; white-space: nowrap" alignFrozen="right" pFrozenColumn class="item-table-col-stock">
                        <span class="flex items-center gap-2 item-table-header-cell"> Stock / Copy error </span>
                    </th>
                    <!-- <th style="width: 100px; white-space: nowrap">
                                <span class="flex items-center gap-2">
                                    Status
                                    <p-columnFilter type="numeric" field="status" display="menu" placeholder="Filter" />
                                </span>
                            </th> -->
                    <th style="width: 80px; min-width: 80px; white-space: nowrap" alignFrozen="right" pFrozenColumn class="item-table-col-actions">
                        <span class="flex items-center gap-2 item-table-header-cell" *ngIf="!readOnly && !isReadOnly"> Actions </span>
                    </th>
                </tr>
            </ng-template>
            <!-- Table Body -->
            <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                <tr
                    [class.bg-red-50]="row.copyOrderStockError"
                    [class.margin-violation-row]="row.marginBelowMinimum"
                    (contextmenu)="onLineRightClick($event, row)"
                >
                    <td style="width: 70px; min-width: 70px">{{ row.lineNumber }}</td>
                    <td style="width: 440px; min-width: 440px; max-width: 440px">
                        <span class="item-name-cell">
                            <span>{{ row.itemName }}</span>
                            <i
                                *ngIf="row.marginBelowMinimum"
                                class="pi pi-exclamation-triangle margin-line-badge"
                                pTooltip="Contribution margin is below the minimum required threshold"
                                tooltipPosition="top"
                                aria-label="Contribution margin below minimum required threshold"
                            ></i>
                        </span>
                    </td>
                    <td style="width: 140px; min-width: 140px">{{ row.itemNumber }}</td>
                    <td style="width: 72px; min-width: 72px">{{ row.m3LineStatus }}</td>  <!-- Bind to m3LineStatus -->
                    <td style="width: 80px; min-width: 80px">
                        <ng-container *ngIf="isEditingRates; else staticQuantity">
                            <input
                                #quantityInputGrid
                                (input)="restrictRowDecimals($event, row, 'quantity')"
                                type="number"
                                [(ngModel)]="row.quantity"
                                (focus)="selectAll($event); previousQty(row, rowIndex)"
                                (onselect)="previousQty(row, rowIndex)"
                                (keydown.arrowUp)="$event.preventDefault();focusPrevQuantityInputGridUp(rowIndex)"
                                (keydown.arrowDown)="$event.preventDefault();focusNextQuantityInputGridDown(rowIndex)"
                            
                                (blur)="onQuantityBlur(row, rowIndex)"
                                (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); onQuantityBlur(row, rowIndex); focusRateInputGrid(rowIndex)"
                                class="p-inputtext p-component w-full"
                                aria-label="Edit Quantity"
                                step="0"
                                [attr.min]="isCreditNoteOrder ? null : 0"
                            />
                        </ng-container>
                        <ng-template #staticQuantity>{{
                            isCreditNoteOrder
                                ? (row.quantity | number: getQtyDisplayFormat(row))
                                : (row.quantity < 0.01 ? 0.01 : (row.quantity | number: getQtyDisplayFormat(row)))
                        }}</ng-template>
                    </td>
                    <td style="width: 120px; min-width: 120px">
                        <ng-container *ngIf="isEditingRates; else staticRateRate">
                            <input
                                #rateInputGrid
                                   (input)="restrictRowDecimals($event, row, 'rate')"
                                type="number"
                                (focus)="selectAll($event); previousRate(row)"
                                [(ngModel)]="row.rate"
                                (keydown.arrowUp)="$event.preventDefault();focusPrevRateInputGridUp(rowIndex)"
                                (keydown.arrowDown)="$event.preventDefault();focusNextRateInputGridDown(rowIndex)"
                                (blur)="row.rate = row.rate < 0.01 ? 0.01 : row.rate; validateRate(row, rowIndex)"
                                (keydown.enter)="onRateEnterTable(rowIndex)"
                                class="p-inputtext p-component w-full"
                                aria-label="Edit Rate"
                                min="0.01"
                            />
                            <div *ngIf="row.rateError" class="text-red-500 text-xs mt-1">{{ row.rateError }}</div>
                        </ng-container>
                        <ng-template #staticRateRate>{{ row.rate < 0.01 ? 0.01 : (row.rate | number: '1.2-2') }}</ng-template>
                    </td>
                    <td style="width: 100px; min-width: 100px" *ngIf="division !== '400'">
                        <ng-container *ngIf="isEditingRates; else staticDiscount">
                            <input
                                #discountInputGrid
                                type="number"
                                [(ngModel)]="row.discount"
                                (focus)="previousDiscount(row)"
                                (ngModelChange)="onDiscountChange(row, $event)"
                                (input)="restrictRowDecimals($event, row, 'discount')"
                                (keydown.arrowUp)="$event.preventDefault(); focusPrevDiscountInputGridUp(rowIndex)"
                                (keydown.arrowDown)="$event.preventDefault(); focusNextDiscountInputGridDown(rowIndex)"
                                (blur)="emitOnDiscountBlur(row, rowIndex)"
                                (keydown.enter)="focusNextQuantityInputGrid(rowIndex)"
                                class="p-inputtext p-component w-full"
                                aria-label="Edit Discount"
                                min="0"
                                max="100"
                                step="0.01"
                            />
                        </ng-container>
                        <ng-template #staticDiscount>{{ row.discount }}</ng-template>
                    </td>
                    <!-- New Discount Value Column -->
                    <td style="width: 140px; min-width: 140px" *ngIf="division !== '400'">
                        {{ row.amount - row.amountAfterDiscount || row.discountAmount | number: '1.2-2' }}
                    </td>
                    <!-- Amount (readonly, always static) -->
                    <td style="width: 140px; min-width: 140px">{{ row.amount | number: '1.2-2' }}</td>
                    <td style="width: 100px; min-width: 100px">{{ row.amountAfterDiscount | number: '1.2-2' }}</td>
                    <td style="width: 90px; min-width: 90px" *ngIf="showMarginColumns">
                        <span
                            class="margin-actual-cell"
                            [class.margin-actual--below]="row.marginBelowMinimum"
                            [class.margin-actual--ok]="!row.marginBelowMinimum && row.calculatedMargin != null"
                            [pTooltip]="getLineMarginTooltip(row)"
                            tooltipPosition="top"
                        >{{ formatMarginPercent(row.calculatedMargin) }}</span>
                    </td>
                    <td style="width: 80px; min-width: 80px" *ngIf="showMarginColumns">
                        {{ formatMarginPercent(row.minimumMargin ?? row.itemMcm) }}
                    </td>
                    <td style="width: 140px; min-width: 140px">{{ row.vat }}</td>
                    <td style="width: 120px; min-width: 120px" class="item-table-col-vat-amt">
                        {{ roundForDisplay(row.vatAmount) || roundForDisplay((row.amountAfterDiscount * row.vat) / 100) }}
                    </td>
                    <!-- row.amountAfterVat -->
                    <td style="width: 120px; min-width: 120px" class="item-table-col-ln-amt">{{ roundForDisplay(row.amountAfterVat) || roundForDisplay(row.amountAfterDiscount + row.vatAmount) }}</td>
                    <td style="width: 120px; min-width: 120px" alignFrozen="right" pFrozenColumn class="item-table-col-stock">
                        <ng-container *ngIf="!shouldHideStockInfo(row) && row.copyOrderStockError">
                            <span class="flex items-center gap-1 text-red-600" [pTooltip]="row.copyOrderStockError" tooltipPosition="top">
                                <i class="pi pi-exclamation-triangle"></i>
                                <span class="text-sm">{{ row.copyOrderStockError }}</span>
                            </span>
                        </ng-container>
                        <ng-container *ngIf="!shouldHideStockInfo(row) && !row.copyOrderStockError && row.avlStock != null">
                            <span class="text-surface-600 text-sm">Avl: {{ row.avlStock }}</span>
                        </ng-container>
                    </td>
                    <!-- Status Column -->
                    <!-- <td style="width: 100px">{{ row.status }}</td> -->
                    <td style="width: 80px; min-width: 80px" alignFrozen="right" pFrozenColumn class="item-table-col-actions">
                        <div class="flex gap-2">
                            <!-- <p-button icon="pi pi-pencil" class="mr-2" (onClick)="editItem(row, rowIndex)" outlined aria-label="Edit"></p-button> -->
                            <p-button icon="pi pi-trash" *ngIf="!readOnly && !isReadOnly" severity="danger" (onClick)="deleteItem(rowIndex)" outlined aria-label="Delete"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<!-- Add this at the end of the file, before </div> or after <p-confirmDialog> -->
    <p-toast position="top-right" key="custom-toast" [baseZIndex]="5000">
        <ng-template let-message pTemplate="message">
            <div class="flex flex-col items-start flex-auto">
                <div class="font-bold text-xl mb-2">{{ message.summary }}</div>
                <div class="font-medium text-lg">{{ message.detail }}</div>
            </div>
        </ng-template>
    </p-toast>
    <p-confirmDialog></p-confirmDialog>
    <app-prepost-text-wizard [(visible)]="showLineTextWizardDialog" [textType]="selectedLineTextType" (complete)="onLinePrePostComplete($event)"></app-prepost-text-wizard>
